export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';

export const TIMEOUT_SEC = 2;

export const RES_PER_PAGE = 10;

export const KEY = '6f171b1b-7a45-4d91-a428-b1185abfda29';
// export const KEY = 'baaa8526-5076-41d6-a1bd-4c440b649037';
